// 企业准入类型
export enum ACCESS_TYPE {
  jrdw = 1,
  sydw
}
// 乐企单位状态
export enum UNIT_STATUS {
  yc = -1, // 异常
  wtb, // 未同步
  zc, // 政策
  tbz // 同步中
}
// 能力状态
export enum ABILITY_STATUS {
  ykt = '00', // 已开通
  dcs = '01', // 待测试
  shz = '02', // 审核中
  wkt = '98', // 未开通
  yc = '99' // 异常
}
export enum APPLICATION_STATUS {
  ty = '0',
  qy = '1'
}
// 性别
export enum SEX {
  man = 1,
  woman
}
// 员工状态
export enum ACCOUNT_STATUS {
  TY, // 停用
  JH, // 激活
  WJH // 未激活
}
// 后台-日志-登录日志-认证结果
export enum CERTIFICATION_RESULT {
  CG = 1, // 成功
  SB // 失败
}

// 自定义字段label
export enum FIELD_LABLE {
  JXFP = 1, // 进项发票
  XXFP, // 销项发票
  FPLP, // 发票列表
  FPJL, // 发票记录
  DKGX, // 抵扣勾选
  RZGX, // 入账勾选
  DKLZP, // 待开蓝字发票
  DKHZFP, // 待开红字发票
  HZQRDCL, // 红字确认单处理
  HZQRDLL, // 红字确认单录入
  PZHJJ, // 开票-蓝字发票-批量记录-当前批次数据
  DZKJ = 13, // 开票-蓝字发票-单张开具
  DDLB, // 订单管理
  DKDDLB, // 待开订单列表
  TSGX = 18, // 退税勾选
  ZNGX = 20 // 智能勾选
}
// 仪表盘-时间类型
export enum SJLX {
  Y = '1', // 按月度
  JD = '2', // 按季度
  ND = '3' // 按年度
}
// 发票池-勾选状态
export enum GXZT {
  WGX = '00', // 未勾选
  SQDK = '01', // 申请抵扣
  CXDK = '02', // 撤销抵扣
  SQBDK = '03', // 申请不抵扣
  CXBDK = '04' // 撤销不抵扣
}
// 发票池-不抵扣类型
export enum BDKLX {
  YYFYSXM = 1, // 用于非应税项目
  YYMSXM, // 用于免税项目
  YYJTFLHZGRXF, // 用于集体福利或者个人消费
  ZSFZCSS, // 遭受非正常损失
  QT // 其他
}
// 发票池-处理结果
export enum CLJG {
  CG = '1', // 入账（撤销）成功
  CWCP = '2', // 查无此票
  YC = '3', // 该票异常无法入账
  CFRZ = '4', // 重复入账
  QT = '5' // 其他
}
// 发票池-勾选处理结果
export enum GXCLJG {
  GXCG = '01', // 勾选（撤销）成功
  CWCP = '02', // 查无此票
  YC = '03', // 该票异常无法勾选
  YQ = '04', // 该票已经逾期无法认证
  SD = '05', // 当期已锁定（已申请统计）
  CF = '06', // 已勾选无法重复勾选
  WDQ = '07', // 未到期不可勾选（填发月份大于当前属期）
  HMCF = '13', // 该票号码重复
  QT = '99' // 其它
}
// 发票池-勾选类型代码
export enum GXLXDM {
  SQDK = '01', // 申请抵扣
  CXDK = '02', // 撤销抵扣
  SQBDK = '03', // 申请不抵扣
  CXBDK = '04' // 撤销不抵扣
}
// 发票池-申请入账类型
export enum SQRZLX {
  WRZ = '00', // 未入账
  SQKC = '02', // 入账（企业所得税税前扣除）
  SQBKC = '03', // 入账（企业所得税不扣除）
  JYSDKC = '04', // 入账（个人所得税经营所得税前扣除）
  JYSDBKC = '05', // 入账（个人所得税经营所得不扣除）
  CX = '06' // 入账撤销
}
// 发票池-税种
export enum SZ {
  ZZS = '2', // 增值税,
  XFS = '3' // 消费税
}
// 发票池-发票流转状态
export enum FPLZZT {
  FPWCJ = '1', // 发票未签收
  FPYCJ = '2', // 发票已签收
  FPYRZ = '3', // 发票已入账
  FPYGD = '4' // 发票已归档
}
// 发票池-发票状态
export enum FPZT {
  ZC = '0', // 正常
  ZF = '2', // 作废
  YCH = '3', // 已红冲
  BFHZ = '7', // 部分红冲
  QBHC = '8' // 全额冲红
}
// 发票池-异常凭证状态
export enum YCPZZT {
  ZC = '01', // 正常
  YCPZ = '02', // 异常凭证
  YSYCPZ = '03' // 疑似异常凭证
}
// 发票池-用途状态
export enum YTZT {
  WSY = '0', // 未使用
  YSQDK = '1', // 已申请抵扣
  YSQTS = '2', // 已申请退税
  YSQDBTS = '3', // 已申请代办退税
  YG = '4' // 已勾
}
// 发票池-请单导入状态
export enum QDDRZT {
  DRSB = -1, // 导入失败
  CLZ, // 处理中
  DRCG // 导入成功
}

// 发票池-发票归集记录-归集结果
export enum GJJG {
  SB = '-2', // 失败
  WKS = '-1', // 未开始-等待中
  ZZGj = '0', // 正在归集
  GJCG = '1' // 归集成功
}
// 发票池-发票归集记录-归集类型
export enum GJLX {
  QL = '1', // 全量归集
  ZL = '2', // 增量归集
  CKZNX = '3' // 出口转内销发票
}
// 开票-开票记录详情-差额征税类型代码
export enum CEZSLXDM {
  QRKP = '01', // 全额开票
  CEKP = '02' // 差额开票
}
// 开票-开票记录详情-出口业务适用政策代码
export enum CKYWSYZCDM {
  TSZC = '01', // 退税政策
  MSZC = '02', // 免税政策
  ZSZC = '03' // 征税政策
}
// 开票-开票记录详情-发票行性质
export enum FPHXZ {
  ZCH = '00', // 正常行
  ZKH = '01', // 折扣行
  BZKH = '02' // 被折扣行
}
// 开票-开票记录详情-优惠政策标识
export enum YHZCBS {
  JYZS = '01', // 简易征收
  XTCP = '02', // 稀土产品
  MS = '03', // 免税
  BZS = '04', // 不征税
  XZHT = '05', // 先征后退
  XZHT100 = '06', // 100%先征后退
  XZHT50 = '07', // 50%先征后退
  JYZS3 = '08', // 按3%简易征收
  JYZS5 = '09', // 按5%简易征收
  JZ = '10', // 按5%简易征收减按1.5%计征
  JZJT30 = '11', // 即征即退30%
  JZJT5 = '12', // 即征即退50%
  JZJT70 = '13', // 即征即退70%
  JTJT100 = '14', // 即征即退100%
  CSF3 = '15', // 超税负3%即征即退
  CSF8 = '16', // 超税负8%即征即退
  CSF12 = '17', // 超税负12%即征即退
  CSF6 = '18' // 超税负6%即征即退
}
// 开票-开票记录详情-购买方自然人标志
export enum GMFZRRBZ {
  S = 'Y', // 购买方是自然人
  F = 'N' // 购买方非自然人
}
// 开票-开票记录详情-结算方式
export enum JSFS {
  XJ = '01', // 现金
  YHZZ = '02', // 银行转账
  PJ = '03', // 票据
  DSFZF = '04', // 第三方支付
  YFK = '05', // 预付卡
  QT = '99' // 其他
}
// 开票-开票记录详情-上传状态
export enum SCZT {
  SCCG = '00', // 上传成功
  CLZ = '01', // 发票上传处理中
  SCSB = '02', // 上传失败
  CFSC = '03' // 重复上传
}
// 开票-开票记录详情-上传状态(非乐企状态)
export enum SCZT2 {
  DSC = '00', // 待上传
  DDSC = '01', // 等待上传
  SCCG = '02', // 上传成功
  SCSB = '03', // 上传失败
  YSCCG = '04' // 预上传成功
}
// 开票-开票记录详情-收购发票类型代码
export enum SGFPLXDM {
  RCP = '01', // 农产品收购发票
  GF = '02', // 光伏收购发票
  ESC = '03' // 二手车收购发票
}
// 开票-开票记录详情-特定要素
export enum TDYS {
  FTDYS = '00', // 非特定要素
  CPY = '01', // 成品油
  XT = '02', // 稀土
  JZFW = '03', // 建筑服务
  HWYSFW = '04', // 货物运输服务
  BDCXS = '05', // 不动产销售服务
  BDCZL = '06', // 不动产经营租赁服务
  DSC = '07', // 代收车船税
  TXF = '08', // 通行费
  LKYSFW = '09', // 旅客运输服务
  ZY = '10', // 医疗服务（住院）
  MZ = '11', // 医疗服务（门诊）
  RCPXS = '12', // 自产农产品销售
  TLJ = '13', // 拖拉机和联合收割机
  JDC = '14', // 机动车
  ESC = '15', // 二手车
  RCPSG = '16', // 农产品收购 购销双方反写
  GFSG = '17', // 光伏收购
  JY = '18', // 卷烟
  TLDZKP = '21', // 电子发票（铁路电子客票）
  HKYSKPDZXCD = '22', // 电子发票（航空运输客票电子行程单）
  DZY = '32' // 电子烟
}
// 开票-开票记录-收购发票类型代码
export enum SGFPLXDM {
  RCPSG = '01', // 农产品收购发票
  GFSG = '02', // 光伏收购发票
  ESCSG = '03' // 二手车收购发票
}
// 开票-开票记录详情-增值税即征即退代码
export enum ZZSJZJTDM {
  RJCP = '01', // 软件产品发票
  ZYZHLYCP = '02', // 资源综合利用产品发票
  GDYSFW = '03', // 管道运输服务发票
  YXDCRZZL = '04', // 有形动产融资租赁服务
  YXDCRZXSHHZFW = '05', // 有形动产融资性售后回租服务发票
  XXQTCL = '06', // 新型墙体材料发票
  FLFDCP = '07', // 风力发电产品发票
  GFFDCP = '08', // 光伏发电产品发票
  DMRJCP = '09', // 动漫软件产品发票
  FJWHLW = '10', // 飞机维修劳务发票
  HJ = '11', // 黄金发票
  BJ = '12' // 铂金发票
}
// 开票记录详情-发票来源
export enum FPLY {
  FPGJ = '1', // 发票归集
  FPYZ = '2' // 发票验真
}
// 开票记录详情-结算方式
export enum JSFSDM {
  XJ = '01', // 现金
  YHZZ = '02', // 银行转账
  PJ = '03', // 票据
  DSFZF = '04', // 第三方支付
  YFK = '05', // 预付卡
  QT = '99' // 其他
}
// 开票记录详情-平台勾选状态
export enum PTGXZT {
  WGX = '0', // 未勾选
  JXZ = '1', // 进行中
  DKGX = '2', // 抵扣勾选
  BDKGX = '3' // 不抵扣勾选
}
// 开票记录详情-平台入账状态
export enum PTRZZT {
  WRZ = '0', // 未入账
  JXZ = '1', // 进行中
  SQKCRZ = '2', // 税前扣除入账
  BSQKCRZ = '3' // 不税前扣除入账
}
// 开票记录详情-xml
export enum XML {
  F = '0', // 否
  S = '1', // 是
  FPLX = '51', // 发票类型
  MYXML = '61' // 没有xml
}
// 开票记录详情-消费税用途标签
export enum XFSYTBQ {
  WGX = '00', // 未勾选库存
  YGX = '01' // 已勾选库存
}
// 开票记录详情-增值税用途标签
export enum ZZSYTBQ {
  WSY = '0', // 未使用
  QBXMJJ = '1', // 全部项目加计
  QBXMBJJ = '2', // 全部项目不加计
  BFXMJJ = '3' // 部分项目加计
}
// 开票记录详情-交付状态
export enum JFJL {
  JFYC = '-1', // 交付异常
  WJF = '0', // 未交付
  JFCG = '1', // 交付成功
  JFSB = '2' // 交付失败
}
// 开票-开票记录-开具状态
export enum KJZT {
  DKJ = '00', // 待开具
  KJZ = '01', // 开具中
  KJCG = '02', // 开具成功
  KJSB = '03', // 开具失败
  CGX = '04' // 未提交
}
// 开票-开票记录-打包状态
export enum XZZT {
  XZZ = '0', // 打包中
  XZCC = '1', // 打包成功
  XZSB = '-1' // 打包失败
}
// 开票-确认单详情-蓝字发票票种代码
export enum LZFPPZDM {
  ZZS = '01', // 增值税专用发票
  PT = '02', // 普通发票
  JDC = '03', // 机动车统一销售发票
  ESC = '04' // 二手车统一销售发票
}
// 开票-确认单详情-是否纸质发票标志
export enum SFZZFPBZ {
  S = 'Y', // 纸质发票
  F = 'N' // 电子发票
}
// 开票-确认单详情-已开具红字发票标志
export enum YKJJZFPBZ {
  S = 'Y', // 已开具
  F = 'N', // 未开具
  KJZ = 'I', // 开具中
  KJSB = 'E' // 开具失败
}
// 开票-确认单详情-有效标志
export enum YXBZ {
  S = 'Y', // 有效
  F = 'N' // 无效
}
// 开票-订单管理-开具状态
export enum DDKJZT {
  DTJ = '01', // 未提交
  BKP = '02', // 不开票
  LPKJZ = '03', // 蓝票开具中
  LPKJCG = '04', // 蓝票开具成功
  LPKJSB = '05', // 蓝票开具失败
  SQSB = '06', // 申请失败(红字确认单)
  GFQR = '07', // 销方录入待购方确认
  GFFR = '08', // 作废(红字确认单)
  XFCX = '09', // 红票开具中
  GFCX = '10', // 红票开具成功
  CS = '11', // 红票开具失败
  HPKJZ = '12', // 红票开具中
  HPKJCG = '13', // 红票开具成功
  HPKJSB = '14' // 红票开具失败
}
// 发票-蓝字待开列表-发票票种
export enum INVOICE_TYPE {
  ZP = '01', // 数字化（电子专票）
  PP = '02', // 数字化（电子普票）
  JDCXS = '03' // 机动车销售电子统一发票
}
// 发票-红字确认单-红字发票冲红原因代码
export enum CHYYDM {
  KPYW = '01', // 开票有误
  XHTH = '02', // 销货退回
  FWZZ = '03', // 服务中止
  XSZR = '04' // 销售折让
}
// 发票-红字确认单-红字确认单状态
export enum HZQRXXZTDM {
  WXQR = '01', // 无需确认
  DGFQR = '02', // 销方录入待购方确认
  DXFQR = '03', // 购方录入待销方确认
  YQR = '04', // 购销双方已确认
  GFZF = '05', // 作废（销方录入购方否认）
  XFZF = '06', // 作废（购方录入销方否认）
  ZF = '07', // 作废（超72小时未确认）
  CX = '08', // 作废（发起方撤销）
  QRHCX = '09', // 作废（确认后撤销）
  YCPZ = '10' // 作废（异常凭证）
}
// 发票-红字确认单-录入方身份
export enum LRFSF {
  XF = '0', // 销方
  GF = '1' // 购方
}
// 发票-红字确认单-确认即开票
export enum QRJKP {
  F = '0', // 否
  S = '1' // 是
}
// 发票-红字发票确认信息录入-是否含税
export enum SFHS {
  S = 'Y', // 含税
  F = 'N' // 不含税
}
// 发票-红字发票确认信息录入-消费税用途
export enum XFS_YT {
  WGX = '00', // 未勾选用途
  YGX = '01' // 已勾选用途
}
// 发票-红字发票确认信息录入-发票用途
export enum FPYT {
  WSY = '0', // 未使用
  YSSDK = '1', // 已申请抵扣
  YSSTS = '2', // 已申请退税
  YSQDBTS = '3', // 已申请代办退税
  YKXBDK = '4', // 已勾选不抵扣（历史数据）
  YSQDBTS_LSSJ = '5', // 已申请代办退税（历史数据）
  YSQBDK = '6', // 已申请不抵扣
  NXZCK = '7', // 内销转出口
  CKZNX = '8', // 出口转内销
  ZYTS = '9', // 准予退税
  BYTS = '10', // 不予退税
  DATS = '11' // 冬奥退税
}
// 发票-蓝字发票-订单管理-合并拆分标志
export enum HBCFBZ {
  ZC = '00', // 正常
  HB = '01', // 合并
  CF = '02' // 拆分
}
// 用票-抵扣勾选-增值税申报状态
export enum ZZSSBZT {
  WSB, // 未申报
  YSB // 已申报
}
// 用票-退税抵扣-勾选状态
export enum TSGXZT {
  WGX = '0', // 未勾选
  TSGXZ = '1', // 退税勾选中
  YTSGX = '2' // 已退税勾选
}
// 抵扣勾选-统计确认-发票类型
export enum TJQR_FPLX {
  ZZSZYFP = '0', // 增值税专用发票
  TXFFP = '3', // 通行费发票
  QTPTFP = '4', // 其他普通发票
  JDCTYXSFP = '5', // 机动车统一销售发票
  HGJKS = '6', // 海关缴款书
  DKDJWSPZ = '7', // 代扣代缴完税凭证
  ZJ = '8', // 总计
  HKYSKPDZXCD = '21', // 航空运输客票电子行程单
  TLDZKP = '22', // 铁路电子客票
  SGFP = '1', // 收购发票
  ZCRCPPTFP = '2' // 自产农产品普通发票
}
// 统计分析-统计类型
export enum TJFX_TJLX {
  WGX = 'WGX', // 全部未抵扣勾选
  WGX3 = 'WGX3', // 3个月内容未抵扣勾选
  WGX1 = 'WGX1', // 超过一年未抵扣勾选
  YCPZ = 'YCPZ', // 全部异常
  YCPZ3 = 'YCPZ3', // 3个月内异常
  YCPZ1 = 'YCPZ1' // 超过一年异常
}
// 企业管理-是否申报
export enum SFSB {
  WSB = 'N', // 未申报
  YSB = 'Y' // 已申报
}
// 企业管理-汇总确认状态
export enum HZQRZT {
  SB = -1, // 失败
  WTJ, // 未提交
  CG, // 成功
  QRZ, // 确认中
  YCX // 已撤销
}
// 企业管理-推送范围
export enum TSFW {
  YCPZ = '02', // 异常凭证
  YSYCPZ = '03' // 疑似异常凭证
}
// 企业管理-额度操作类型
export enum EDCZRL {
  XZED = '0', // 下载额度
  THED = '1', // 退回额度
  BGSSQ = '2' // 变更所属期
}
// 企业管理-额度操作变更结果
export enum EDBGJG {
  CG = '0', // 成功
  SB = '1' // 失败
}
// 自定义字段-搜索条件
export enum SSTJ {
  K = 0, // 不存在
  DY, // 等于
  BDY, // 不等于
  BH, // 包含
  BBH, // 不包含
  WK, // 为空
  BWK, // 不为空
  DAY, // 大于
  DYDY, // 大于等于
  XY, // 小于
  XYDY // 小于等于
}

// 统计状态
export enum STATISTICS_STATUS {
  wtj = 0, // 未统计
  ytj = 1, // 已统计
  yqr = 2, // 已确认
  tjz = 3, // 统计中
  cxtjz = 4, // 撤销统计中
  qrz = 5, // 确认中
  cxqrz = 6, // 撤销确认中
  tjsb = 7, // 统计失败
  qrsb = 8, // 确认失败
  cxtjsb = 9, // 撤销统计失败
  cxqrsb = 10 // 撤销确认失败
}

// 增值税申报状态
export enum TAX_DECLARATION_STATUS {
  wsb = '01', // 未申报
  ysb = '02' // 已申报
}

// 票据类型
export enum NOTE_TYPE {
  fp = 1, // 发票
  dkdjwspz = 2, // 代扣代缴完税凭证
  hgjks = 3 // 海关缴款书
}

// 签收状态
export enum COLLECTION_STATUS {
  wcj = 0, // 未签收
  ycj = 1 // 已签收
}

// 异常状态
export enum NORMAL_STATUS {
  zc = 1, // 正常
  yc = 2, // 异常
  ysyc = 3 // 疑似异常
}

// 勾选状态
export enum CHECK_STATUS {
  // wgx = '0', // 未勾选
  // dkgxjxz = '1', // 抵扣勾选进行中
  // dkgx = '2', // 抵扣勾选
  // bdkgx = '3', // 不抵扣勾选
  // bdkgxjxz = '4', // 不抵扣勾选进行中
  // cxdkjxz = '5', // 撤销抵扣进行中
  // cxbdkjxz = '6', // 撤销不抵扣进行中
  SQDKZ = '90', // 申请抵扣中
  SQBDKZ = '91', // 申请不抵扣中
  CXDKZ = '92', // 撤销抵扣中
  CXBDKZ = '93' // 撤销不抵扣中
}

// 勾选类型
export enum CHECK_TYPE {
  sqdk = '01', // 申请抵扣
  cxdk = '02', // 撤销抵扣
  sqbdk = '03', // 申请不抵扣
  cxbdk = '04' // 撤销不抵扣
}

// 入账状态
export enum INTO_ACCOUNT_STATUS {
  wrz = '0', // 未入账
  sqkcjxz = '1', // 税前扣除进行中
  sqkcrz = '2', // 税前扣除入账
  bsqkcrz = '3', // 不税前扣除入账
  bsqkcjxz = '4', // 不税前扣除进行中
  sqkccxjxz = '5', // 税前扣除撤销进行中
  bsqkccxjxz = '6' // 不税前扣除撤销进行中
}
export enum RZZT {
  WRZ = '01', // 未入账
  YRZ = '02', // 已入账
  YRZCX = '03' // 已入账撤销
}

// 确认申请标志
export enum CONFIRM_TYPE {
  sqtj = '1', // 申请统计
  cxtj = '2', // 撤销统计
  sqqr = '3', // 申请确认
  cxqr = '4' // 撤销确认
}

// 抵扣勾选所属期设置类型
export enum DKGXSSQSZLX {
  JSYJZZS = 1, // 计算应缴增值税
  ZNGX = 2 // 智能勾选
}

// 智能勾选任务状态
export enum ZNGXRWZT {
  WKS = 1, // 未开始
  JXZ = 2, // 进行中
  YWC = 3 // 已完成
}

// 智能勾选方式
export enum ZNGXFS {
  SFLDS = 0, // 按增值税税负率倒算
  YJZZSDS = 1, // 按应缴增值税倒算
  DKJXSE = 2 // 按录入抵扣进项税额
}

// 智能勾选顺序
export enum ZNGXSX {
  KPSJ = '1', // 开票时间 按开票时间顺序先进先勾选
  QSRQ = '2', // 签收日期 按签收时间顺序先进先勾选
  YXDKSE = '0' // 有效抵扣税额 按有效抵扣税额先大后小勾选
}

// 智能勾选范围
export enum ZNGXFW {
  YCJ = 1, // 已签收发票
  YGJ = 2 // 已归集发票
}

// 智能勾选末尾发票勾选规则
export enum ZNGXMWFPGXGZ {
  BCG = '0', // 不超过 实际勾选结果按不超过设置的税负率
  ZSCG = '1' // 最少超过 实际勾选结果按最少超过设置的税负率
}

// 发票类型
export enum FPLX {
  SYPP = '100', // 所有普票
  SYZP = '200', // 所有专票
  SYQT = '300', // 所有其他
  ZZS_ZYFP_01 = '01', // 增值税专用发票
  HWYSY_ZZS_ZYFP_02 = '02', // 货物运输业增值税专用发票
  JDCXSTYFP_03 = '03', // 机动车销售统一发票
  ZZSPTFP_04 = '04', // 增值税普通发票
  ZZS_DZ_ZYFP_08 = '08', // 增值税电子专用发票
  ZZS_DZPTFP_10 = '10', // 增值税电子普通发票
  JSFP_11 = '11', // 卷式发票
  TXFFP_14 = '14', // 通行费发票
  ESCXSTYFP_15 = '15', // 二手车销售统一发票
  ZZSZYFP_81 = '81', // 电子发票（增值税专用发票）
  DZFP_PTFP_82 = '82', // 电子发票（普通发票）
  SDP_JDCXSTYFP_83 = '83', //	数电票（机动车销售统一发票）
  SDP_ESCXSTIFP_84 = '84', //	数电票（二手车销售统一发票）
  ZZFP_ZZSZYFP_85 = '85', // 纸质发票（增值税专用发票）
  ZZFP_PTFP_86 = '86', // 纸质发票（普通发票）
  FPLX_87 = '87', // 纸质发票（机动车销售统一发票）
  FPLX_88 = '88', // 纸质发票（二手车销售统一发票）
  ZDFP_TLDZKP_51 = '51', // 电子发票（铁路电子客票）
  DZFP_HKYSKPDZXCD_61 = '61', // 电子发票（航空运输客票电子行程单）
  QKLFP_99 = '99', // 区块链发票
  COMMON_100 = '100' //  通用(电子)发票
}
// 发票种类
export enum FPZL {
  LZFP = '0', // 蓝字
  HZFP = '1', // 红字
  HJ = '2' // 合计
}

// 用票勾选规则开启状态
export enum GZKQZT {
  WSZ = 0, // 未设置
  YKQ = 1, // 已开启
  YGB = 2 // 已关闭
}

// 用票勾选规则配置类型
export enum GZPZLX {
  DKGX = '1', // 抵扣勾选
  RZGX = '2', // 入账勾选
  TSGX = '3' // 退回勾选
}

// 用票勾选业务状态
export enum GZYWZT {
  YGJ = 1, // 已归集
  YQS = 2 // 已签收（已签收）
}

// 纳税人类型
export enum NSRLX {
  YBNSR = '1', // 一般纳税人
  XGMNSR = '2', // 小规模纳税人
  ZDJXGMNSR = '3', // 转登记小规模纳税人
  FDQYBNSR = '4', // 辅导期一般纳税人
  ZRR = '5' // 自然人
}

// 风险纳税人类型
export enum FXNSRLX {
  FFXNSR = '', // 非风险纳税人
  ILNSR = '01', // I类（高风险）纳税人
  IILNSR = '02', // II类（中风险）纳税人
  IIILNSR = '03', // II类（低风险）纳税人
  IVLNSR = '04' // IV类（无风险）纳税人
}

// 纳税人预警级别
export enum NSRYJJB {
  WYJ = '', // 无预警
  RYJ = '01', // 红色预警 Red
  YYJ = '02', // 黄色预警 Yellow
  BYJ = '03' // 蓝色预警 Blue
}

// 风险纳税人标志
export enum FXNSRBZ {
  ZC = 'N', // 正常纳税人
  FX = 'Y' // 风险纳税人
}

// 操作记录类型
export enum CZJLLX {
  DKGX = 1, // 抵扣勾选
  SQTJ = 2, // 申请统计
  QRTJ = 3, // 确认统计
  RZGX = 4, // 入账勾选
  TSGX = 5 // 退税勾选
}
// 邮箱列表-邮箱启用状态
export enum YXQYZT {
  QY = '1', // 启用
  TY = '0', // 停用
  Y = 'Y', // 启用
  N = 'N' // 停用
}
// 参数配置-限额预警配置-限制预计范围
export enum XZYJFW {
  DYLJKPECC = '01', // 单月累计开票额超出
  JDLJKPECC = '02', // 季度累计开票额超出
  LXSRGYLJKPECC = '03' // 连续12月累计开票额超出
}
// 参数配置-限额预警配置-限制预警类型
export enum XZYJLX {
  CETX = '01', // 超额提醒
  CEJZKP = '02', // 超额禁止开票
  BSZ = '03' // 不设置
}
// 开票信息管理-附加信息管理-数据类型
export enum FJSJLX {
  RQX = '1', // 日期型
  SZX = '2', // 数值型
  WBX = '3' // 文本型
}
// 发票票种
export enum FPPZ {
  PT = '02', // 电子发票（普通发票）
  ZY = '01' // 电子发票（专用发票）
}
// 客户信息管理
export enum TJFS {
  SD = '1', // 手动
  PLDR = '2', // 批量导入
  SMLR = '3' // 扫码录入
}
// 企业绑定管理-接入单位-是否沙箱
export enum SFSX {
  S = '1', // 是
  F = '0' // 否
}
// 查验结果
export enum CYJG {
  CYSB = -1, // 查验失败
  BKCYPZ, // 不可查验票种
  CYCG // 查验成功
}
// 证件类型
export enum ZJLX {
  DW = '100', // 单位,
  ZZJGDMZ = '101', // 组织机构代码证,
  YYZZ = '102', // 营业执照,
  SSDJZ = '103', // 税务登记证,
  QTDWZJ = '199', // 其他单位证件,
  GR = '200', // 个人,
  JMSFZ = '201', // 居民身份证,
  JGZ = '202', // 军官证,
  WJJGZ = '203', // 武警警官证,
  SBZ = '204', // 士兵证,
  JDLTXGBZ = '205', // 军队离退休干部证,
  CJRZ = '206', // 残疾人证,
  CJJRZ = '207', // 残疾军人证（1-8级）,
  WGHZ = '208', // 外国护照,
  GATB = '209', // 港澳同胞回乡证,
  GATXZ = '210', // 港澳居民来往内地通行证,
  TBZ = '211', // 台胞证,
  ZGGATXZ = '212', // 中华人民共和国往来港澳通行证,
  TWDLTXZ = '213', // 台湾居民来往大陆通行证,
  DLTWTXZ = '214', // 大陆居民往来台湾通行证,
  WGRJZZ = '215', // 外国人居留证,
  WJGZ = '216', // 外交官证,
  SGZ = '217', // 使（领事）馆证,
  HYZ = '218', // 海员证,
  XGYJSFZ = '219', // 香港永久性居民身份证,
  TWSFZ = '220', // 台湾身份证,
  AMSFZ = '221', // 澳门特别行政区永久性居民身份证,
  WGRSFZ = '222', // 外国人身份证件,
  GXCYZ = '223', // 高校毕业生自主创业证,
  SYDJZ = '224', // 就业失业登记证,
  TWZ = '225', // 退休证,
  LWZ = '226', // 离休证,
  ZGFZ = '227', // 中国护照,
  SBZMZYZ = '228', // 城镇退役士兵自谋职业证,
  SZJSSFZ = '229', // 随军家属身份证明,
  ZYZS = '230', // 中国人民解放军军官转业证书,
  TCXYZ = '231', // 中国人民解放军义务兵退出现役证,
  SGTVXYZ = '232', // 中国人民解放军士官退出现役证,
  WGTYJJLSFZ = '233', // 外国人永久居留身份证（外国人永久居留证）,
  JYCYZ = '234', // 就业创业证,
  XGHZ = '235', // 香港特别行政区护照,
  AMHZ = '236', // 澳门特别行政区护照,
  ZGGAJZZ = '237', // 中华人民共和国港澳居民居住证,
  ZGTWJZZ = '238', // 中华人民共和国台湾居民居住证,
  GZXKZA = '239', // 《中华人民共和国外国人工作许可证》（A类）,
  GZXKZB = '240', // 《中华人民共和国外国人工作许可证》（B类）,
  GZXKZC = '241', // 《中华人民共和国外国人工作许可证》（C类）,
  CSZM = '291', // 出生医学证明,
  QTZJ = '299' // 其他个人证件
}
// 交通工具类型
export enum JTGJLX {
  FJ = '1', // 飞机
  HC = '2', // 火车
  CTQC = '3', // 长途汽车
  GGJT = '4', // 公共交通
  CZC = '5', // 出租车
  QC = '6', // 汽车
  CB = '7', // 船舶
  QT = '9' // 其他
}
// 医疗机构类型代码
export enum YLJGLXDM {
  A = 'A', // 医院
  A1 = 'A1', // 综合医院
  A100 = 'A100', // 综合医院
  A2 = 'A2', // 中医医院
  A210 = 'A210', // 中医（综合）医院
  A220 = 'A220', // 中医专科医院
  A221 = 'A221', // 肛肠医院
  A222 = 'A222', // 骨伤医院
  A223 = 'A223', // 针炙医院
  A224 = 'A224', // 按摩医院
  A229 = 'A229', // 其他中医专科医院
  A3 = 'A3', // 中西医结合医院
  A300 = 'A300', // 中西医结合医院
  A4 = 'A4', // 民族医院
  A411 = 'A411', // 蒙医院
  A412 = 'A412', // 藏医院
  A413 = 'A413', // 维医院
  A414 = 'A414', // 傣医院
  A419 = 'A419', // 其他民族医院
  A5 = 'A5', // 专科医院
  A511 = 'A511', // 口腔医院
  A512 = 'A512', // 眼科医院
  A513 = 'A513', // 鼻喉科医院
  A514 = 'A514', // 肿瘤医院
  A515 = 'A515', // 心血管病医院
  A516 = 'A516', // 胸科医院
  A517 = 'A517', // 血液病医院
  A518 = 'A518', // 妇产（科）医院
  A519 = 'A519', // 儿童医院
  A520 = 'A520', // 精神病医院
  A521 = 'A521', // 传染病医院
  A522 = 'A522', // 皮肤病医院
  A523 = 'A523', // 结核病及院
  A524 = 'A524', // 麻风病医院
  A525 = 'A525', // 职业病医院
  A526 = 'A526', // 骨科医院
  A527 = 'A527', // 康复医院
  A528 = 'A528', // 整形外科医院
  A529 = 'A529', // 美容医院
  A539 = 'A539', // 其他专科医院
  A6 = 'A6', // 疗养院
  A600 = 'A600', // 疗养院
  A7 = 'A7', // 护理院（站）
  A710 = 'A710', // 护理院
  A720 = 'A720', // 护理站
  B = 'B', // 社区卫生服务中心（站）
  B1 = 'B1', // 社区卫生服务中心
  B100 = 'B100', // 社区卫生服务中心
  B2 = 'B2', // 社区卫生服务站
  B200 = 'B200', // 社区卫生服务站
  C = 'C', // 卫生院
  C2 = 'C2', // 乡镇卫生院
  C210 = 'C210', // 中心卫生院
  C220 = 'C220', // 乡卫生院
  D = 'D', // 门诊部、诊所、医务室、村卫生室
  D1 = 'D1', // 门诊部
  D110 = 'D110', // 综合门诊部
  D120 = 'D120', // 中医门诊部
  D121 = 'D121', // 中医（席合）门诊部
  D122 = 'D122', // 中医专科门诊部
  D130 = 'D130', // 中西医结合门诊部
  D140 = 'D140', // 民族医门诊部
  D150 = 'D150', // 专科门诊部
  D151 = 'D151', // 并通专科门诊部
  D152 = 'D152', // 口腔门诊部
  D153 = 'D153', // 眼科门诊部
  D154 = 'D154', // 医疗美容门诊部
  D155 = 'D155', // 精神卫生门诊部
  D159 = 'D159', // 其他专科门诊部
  D2 = 'D2', // 诊所
  D211 = 'D211', // 普通诊所
  D212 = 'D212', // 中医诊所
  D213 = 'D213', // 中西医结合诊所
  D214 = 'D214', // 民族医诊所
  D215 = 'D215', // 口腔诊所
  D216 = 'D216', // 医疗美容诊所
  D217 = 'D217', // 精神卫生诊所
  D229 = 'D229', // 其他诊所
  D3 = 'D3', // 卫生所（室）
  D300 = 'D300', // 卫生所（室）
  D4 = 'D4', // 医务室
  D400 = 'D400', // 医务室
  D5 = 'D5', // 中小学卫生保健所
  D500 = 'D500', // 中小学卫生保健所
  D6 = 'D6', // 村卫生室
  D600 = 'D600', // 村卫生室
  E = 'E', // 急救中心（站）
  E1 = 'E1', // 急救中心
  E100 = 'E100', // 急救中心
  E2 = 'E2', // 急救中心站
  E200 = 'E200', // 急救中心站
  E3 = 'E3', // 急救站
  E300 = 'E300', // 急救站
  F = 'F', // 采供血机构
  F1 = 'F1', // 血站
  F110 = 'F110', // 血液中心
  F120 = 'F120', // 中心血站
  F130 = 'F130', // 基层血站、中心血库
  F2 = 'F2', // 单采血浆站
  F200 = 'F200', // 单采血浆站
  G = 'G', // 妇幼保健院（所、站）
  G1 = 'G1', // 妇幼保健院
  G100 = 'G100', // 妇幼保健院
  G2 = 'G2', // 妇幼保健所
  G200 = 'G200', // 妇幼保健所
  G3 = 'G3', // 妇幼保健站
  G300 = 'G300', // 妇幼保健站
  G4 = 'G4', // 生殖保健中心
  G400 = 'G400', // 生殖保健中心
  H = 'H', // 专科疾病防治院（所、站）
  H1 = 'H1', // 专科疾病防治院
  H111 = 'H111', // 传染病防治院
  H112 = 'H112', // 结核病防治院
  H113 = 'H113', // 职业病防治院
  H119 = 'H119', // 其他专科疾病防治院
  H2 = 'H2', // 专科疾病防治所（站、中心）
  H211 = 'H211', // 口腔病防治所（站、中心）
  H212 = 'H212', // 精神病防治所（站、中心）
  H213 = 'H213', // 皮肤病防治所（站、中心）
  H214 = 'H214', // 结核病防治所（站、中心）
  H215 = 'H215', // 麻凤病防治所（站、中心）
  H216 = 'H216', // 职业病防治所（站、中心）
  H217 = 'H217', // 寄生虫病防治所（站、中心）
  H218 = 'H218', // 地方病防治所（站，中心）
  H219 = 'H219', // 血吸虫病防治所（站、中心）
  H220 = 'H220', // 药物戒毒所（中心）
  H229 = 'H229', // 其他专科疾病防治所（站、中心）
  J = 'J', // 疾病预防控制中心（防疫站）
  J1 = 'J1', // 疾病预防控制中心
  J100 = 'J100', // 疾病预防控制中心
  J2 = 'J2', // 卫生防疫站
  J200 = 'J200', // 卫生防疫站
  J3 = 'J3', // 卫生防病中心
  J300 = 'J300', // 卫生防病中心
  J4 = 'J4', // 预防保健中心
  J400 = 'J400', // 预防保健中心
  K = 'K', // 卫生监督所（局）
  K1 = 'K1', // 卫生监督所（局）
  K100 = 'K100', // 卫生监督所（局）
  L = 'L', // 卫生监督检验（监测、检测）所（站）
  L1 = 'L1', // 卫生（综合）监督检验（监测，检测）所（站）
  L100 = 'L100', // 卫生（综合）监督检验（监测，检测）所（站）
  L2 = 'L2', // 环境卫生监悴检验（监测、检测）所（站）
  L200 = 'L200', // 坏境卫生监督检验（监测、检测）所（站）
  L3 = 'L3', // 放射卫生监督检验（监测、检测）所（站）
  L300 = 'L300', // 放射卫生监督检验（监测、检测）所（站）
  L4 = 'L4', // 劳动（职业、工业）卫生监督检验（监测、检测）所（站）
  L400 = 'L400', // 劳动（职业、工业）卫生监督检验（监测、检测）所（站）
  L5 = 'L5', // 食品卫生监督检验（监测、检测）所（站）
  L500 = 'L500', // 食品卫生监督检验（监测、检测）所（站）
  L6 = 'L6', // 学校卫生监督检验（监测、检测）所（站）
  L600 = 'L600', // 学校卫生监督检验（监测、检测）所（站）
  L9 = 'L9', // 其他卫生监督检验（监测，检测）所（站）
  L900 = 'L900', // 其他卫生监督检验（监测，检测）所（站）
  M = 'M', // 医学科学研究机构
  M1 = 'M1', // 医学科学（研究）院（所）
  M100 = 'M100', // 医学科学（研究）院（所）
  M2 = 'M2', // 预防医学研究院（所）
  M200 = 'M200', // 预防医学研究院（所）
  M3 = 'M3', // 中医（药）研究院（所）
  M300 = 'M300', // 中医（药）研究院（所）
  M4 = 'M4', // 中西医结合研究所
  M400 = 'M400', // 中西医结合研究所
  M5 = 'M5', // 民族医（药）学研究所
  M500 = 'M500', // 民族医（药）学研究所
  M6 = 'M6', // 医学专科研究所
  M611 = 'M611', // 基础医学研究所
  M612 = 'M612', // 病毒学研究所
  M613 = 'M613', // 老年医学研究所
  M614 = 'M614', // 肿瘤（防治）研究所
  M615 = 'M615', // 心血管病研究所
  M616 = 'M616', // 血液学研究所
  M617 = 'M617', // 整形外科研究所
  M618 = 'M618', // 特种卫生研究所
  M619 = 'M619', // 放射医学研究所
  M620 = 'M620', // 医学生物学研究所
  M621 = 'M621', // 生物医学工程研究所
  M622 = 'M622', // 实验动物研究所
  M623 = 'M623', // 结核病防治研究所
  M624 = 'M624', // 皮肤病与性病防治研究所
  M625 = 'M625', // 寄生虫病防治研允所
  M626 = 'M626', // 地方病防治研究所
  M627 = 'M627', // 血吸虫病防治研究所
  M628 = 'M628', // 流行病学研究所
  M629 = 'M629', // 医学微生物学研究所
  M630 = 'M630', // 环境卫生研究所
  M631 = 'M631', // 劳动卫生（职业病）研究所
  M632 = 'M632', // 营养与食品卫生研究所
  M633 = 'M633', // 儿少卫生研究所
  M634 = 'M634', // 医学信息研究所
  M649 = 'M649', // 其他医学专科研究所
  M7 = 'M7', // 药学研究所
  M700 = 'M700', // 药学研究所
  N = 'N', // 医学教育机构
  N1 = 'N1', // 医学普通高中等学校
  N110 = 'N110', // 医学普通高等学校
  N111 = 'N111', // 医学院
  N112 = 'N112', // 中医（药）学院
  N113 = 'N113', // 民族医（药）学院
  N119 = 'N119', // 其他医学普通高等学校
  N120 = 'N120', // 医学普通中等专业学校
  N121 = 'N121', // 卫生学校
  N122 = 'N122', // 中医（药）学校
  N123 = 'N123', // 民族医（药）学校
  N124 = 'N124', // 护士学校
  N129 = 'N129', // 其他医学普通中等专业学校
  N2 = 'N2', // 医学成人学校
  N210 = 'N210', // 医学成人高等学校
  N211 = 'N211', // 职工医学院
  N212 = 'N212', // 卫生管理干部学院
  N219 = 'N219', // 其他医学成人高等学校
  N220 = 'N220', // 医学成人中等学校
  N221 = 'N221', // 卫生职业（工）中等专业学校
  N222 = 'N222', // 中医（药）职业中等专业学校
  N223 = 'N223', // 卫生进修学校
  N229 = 'N229', // 其他医学成人中等学校
  N3 = 'N3', // 医学在职培训机构
  N300 = 'N300', // 医学在职培训机构
  O = 'O', // 健康教育所（站、中心）
  O1 = 'O1', // 健康教育所
  O100 = 'O100', // 健康教育所
  O2 = 'O2', // 健康教育站（中心）
  O200 = 'O200', // 健康教育站（中心）
  P = 'P', // 其他卫生机构
  P1 = 'P1', // 临床检验中心（所、站）
  P110 = 'P110', // 临床检验中心
  P120 = 'P120', // 临床检验所（站）
  P2 = 'P2', // 卫生新闻出版杜
  P210 = 'P210', // 卫生图书出版社
  P220 = 'P220', // 卫生报纸出版社
  P230 = 'P230', // 卫生杂志社
  P290 = 'P290', // 其他卫生新闻出版社
  P9 = 'P9', // 其他卫生事业机构
  P911 = 'P911' // 精神病收容所
}
// 医保类型代码
export enum YBLXDM {
  ZGJBYLBX = '01', // 职工基本医疗保险
  CXJMJBYLBX = '02', // 城乡居民基本医疗保险
  LX = '03', // 离休
  QTYLBX = '04', // 其他医疗保险
  ZF = '05' // 自费
}
// 智能勾选-处理状态
export enum CLZT {
  DCL = '0', // 待处理
  CXCG = '1', // 查询成功
  CXZ = '2', // 查询中
  CXSB = '3' // 查询失败
}
// 红字确认单-获取确认单记录
export enum CZZT {
  DRSB = -1, // 导入失败
  CLZ, // 处理中
  DRCG // 导入成功
}
// 增值税申报进项抵扣汇总
export enum ZZSSBJXDKHZ {
  ZZSZYFP = '0', // 本期认证相符的增值税专用发票
  HGJKS = '1', // 海关进口增值税缴款书
  NCPHZXSFP = '2', // 农产品收购发票或者销售发票
  DKDJSSJKPZ = '3', // 代扣代缴税收缴款凭证
  JJKCNCP = '4', // 加计扣除农产品进项税额
  WMQYJX = '5', // 外贸企业进项税额抵扣证明
  YCPZ = '6' // 本期认证相符的解除异常凭证
}
// 农产品加计扣除勾选统计结果
export enum RCPJJKCGXTJJG {
  ZZSZYFP = '9', // 增值税专用发票
  SGFP = '10', // 收购发票
  MSZCNCP = '11', // 免税自产农产品普通发票
  HGJKS = '12', // 海关缴款书
  YXDK = '13' // 录入本期有效抵扣税额
}
// 支付渠道
export enum ZFQD {
  XJ = '001', // 现金
  YHZZ = '002', // 银行转账
  PJ = '003', // 票据
  JJK = '004', // 借记卡
  XYK = '005', // 信用卡
  GWK = '006', // 购物卡/券
  YHJ = '007', // 优惠券
  SCJF = '008', // 商场积分
  ZFB = '009', // 支付宝
  WXZF = '010', // 微信支付
  YSF = '011', // 云闪付
  APPLE_PAY = '012', // Apple Pay
  SAMSUNG_PAY = '013', // Samsung Pay
  QT = '099' // 其它
}
// 煤炭种类
export enum MTZL {
  ZFBGM = '0100', // 政府保供煤
  CXY_0 = '0201', // 长协煤-协议期不足半年
  CXY_1 = '0202', // 长协煤-协议期在半年至一年之间
  CXY_2 = '0203', // 长协煤-协议期在一年至两年之间
  CXY_3 = '0204', // 长协煤-协议期在两年以上
  SCM = '0300' // 市场煤
}
